import { VIEW_CHECKOUT_CONST, type CheckoutViewProps } from './CheckoutView.d';
import { Checkout } from './CheckoutView.styles';

const CheckoutView = ({ children, testid }: CheckoutViewProps) => (
  <Checkout.Container data-testid={VIEW_CHECKOUT_CONST.TEST_ID} marginTop="sp-4" size="1/2">
    <Checkout.Component data-testid={testid}>{children}</Checkout.Component>
  </Checkout.Container>
);

export default CheckoutView;
